<template>
  <div class="para" style="margin-top: 0">
    <!--
              ****  メッセージ表示領域 **** -->
    <p class="errMsg" id="outMessageArea"></p>
    <!--                          -->
    <div class="frm-btn-row" style="align-items: flex-start; margin-top: 0">
      <div class="frm-item grow left">
        アカウント情報の変更、ログイン状況の確認を行えます。
      </div>
      <!-- <div class="frm-item grow right">
        <button
          class="frm-btn ico ico-import"
          type="button"
          data-role="popup-open"
          data-target="#popup-import"
        >
          インポート
        </button>
        <button
          class="frm-btn ico ico-export"
          type="button"
          data-role="popup-open"
          data-target="#popup-export"
        >
          エクスポート
        </button>
      </div> -->
    </div>
    <!-- ******************************************************************
                 *  フィルタ条件                                                  *
                 ****************************************************************** -->
    <div class="criteria">
      <!-- ******************************************************************
                   *  一覧検索                                                      *
                   ****************************************************************** -->
      <div class="frm-row">
        <div class="frm-item grow left">
          <div
            class="frm-search frm-size-xl"
            :class="searchKey ? 'setvalue' : ''"
          >
            <span class="frm-label" style="margin-left: 0.5em">
              <img src="../../../assets/images/TDSDC/icon_search.png" />
            </span>
            <input
              id="filter"
              type="search"
              size="43"
              class="frm-search-text"
              placeholder="検索キーワード"
              maxlength="255"
              v-model.trim="searchKey"
              ref="refSearchKey"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- ******************************************************************
                 *  アクセスログ一覧                                              *
                 ****************************************************************** -->
    <div class="table-wrap" style="margin-top: 0px">
      <div class="frm-row">
        <div class="frm-item grow right">
          <p>{{ countStr }}</p>
        </div>
      </div>
      <div class="table-scroll-header">
        <table class="table-select single-select">
          <colgroup>
            <col style="width: 170px" />
            <col style="width: auto" />
            <!--<col style="width: 150px;">-->
            <col style="width: 150px" />
            <col style="width: 200px" />
            <col style="width: 150px" />
            <col style="width: 250px" />
          </colgroup>
          <thead>
            <tr>
              <th class="sort hover alignleft" @click="sortData('tatsuzinId')">
                ログインID
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'tatsuzinId' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'tatsuzinId' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="sort hover alignleft" @click="sortData('userName')">
                利用者名
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'userName' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'userName' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <!-- <th class="sort hover" @click="sortData('loginStatus')">
                ログイン状況
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'loginStatus' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="
                      sort.key == 'loginStatus' && !sort.isAsc ? 'on' : ''
                    "
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th> -->
              <th class="sort hover" @click="sortData('accountStatus')">
                アカウント状態
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="
                      sort.key == 'accountStatus' && sort.isAsc ? 'on' : ''
                    "
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="
                      sort.key == 'accountStatus' && !sort.isAsc ? 'on' : ''
                    "
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="sort hover" @click="sortData('lastSignedinDateTime')">
                最終ログイン日時
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="
                      sort.key == 'lastSignedinDateTime' && sort.isAsc
                        ? 'on'
                        : ''
                    "
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="
                      sort.key == 'lastSignedinDateTime' && !sort.isAsc
                        ? 'on'
                        : ''
                    "
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="sort hover" @click="sortData('lastSigninIpAddress')">
                IPアドレス
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="
                      sort.key == 'lastSigninIpAddress' && sort.isAsc
                        ? 'on'
                        : ''
                    "
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="
                      sort.key == 'lastSigninIpAddress' && !sort.isAsc
                        ? 'on'
                        : ''
                    "
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>

              <th></th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table-scroll-body h-500px">
        <table class="table-select multi-select">
          <colgroup>
            <col style="width: 170px" />
            <col style="width: auto" />
            <!--<col style="width: 150px;">-->
            <col style="width: 150px" />
            <col style="width: 200px" />
            <col style="width: 150px" />
            <col style="width: 250px" />
          </colgroup>
          <tbody>
            <tr
              v-for="accountData in displayAccountDataList"
              :key="accountData.id"
            >
              <td>
                <span
                  v-show="accountData.passwordChangeRequest"
                  class="password-change"
                ></span
                >{{ accountData.tatsuzinId }}
              </td>
              <td>{{ accountData.userName }}</td>
              <!-- <td align="center">
                {{ accountData.loginStatusValue }}
                <br />
                <button
                  class="frm-btn-operation"
                  type="button"
                  :disabled="
                    accountData.loginStatus === 2 ||
                    accountData.permissonType === 1
                  "
                  @click="loginStatusChange(accountData)"
                >
                  強制ログアウト
                </button>
              </td> -->
              <td align="center">
                {{ accountData.accountStatus }}
                <br />
                <button
                  class="frm-btn-operation"
                  style="padding: 2px 20px"
                  type="button"
                  @click="accountStatusChange(accountData)"
                  :disabled="accountData.tatsuzinId === currentTatsuzinId"
                >
                  変更
                </button>
              </td>
              <td align="center">
                {{ accountData.lastSignedinDateTimeFormat }}
              </td>
              <td align="center">{{ accountData.lastSigninIpAddress }}</td>
              <td align="center">
                <div class="frm-row separate">
                  <div class="frm-item">
                    <button
                      class="frm-btn-operation ico ico-edit"
                      type="button"
                      @click="handleEdit(accountData)"
                    >
                      編集
                    </button>
                  </div>
                  <div class="frm-item">
                    <button
                      class="frm-btn-operation ico ico-pwChange"
                      type="button"
                      @click="passwordChange(accountData)"
                    >
                      パスワード変更
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table-select single-select" v-show="noDataFlag">
          <tbody>
            <tr>
              <p class="noData-area">
                {{ noDataMsg }}
              </p>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <ConfirmDialog
    :isShow="isLoginStatusChangeShow"
    :message="loginStatusChangeMessage"
    @confirm="loginStatusChangeConfirm"
    @cancel="loginStatusChangeCancel"
  ></ConfirmDialog>
  <ConfirmDialog
    :isShow="isAccountStatusChangeShow"
    :message="accountStatusChangeMessage"
    @confirm="accountStatusChangeConfirm"
    @cancel="accountStatusChangeCancel"
  ></ConfirmDialog>
  <PasswordChangeModal
    :isShow="isPasswordChangeShow"
    :loginId="passwordChangeTatsuzinId"
    :initialLoginId="passwordChangeTatsuzinId"
    :userName="passwordChangeUserName"
    :userKeyName="passwordChangeUserKeyName"
    :userAuthorityType="passwordChangeUserAuthorityType"
    :passwordChangeRequestFlag="passwordChangeRequestFlag"
    :parentPageId="pageId"
    :accountData="passwordChangeAccountData"
    @close="isPasswordChangeShow = false"
    @getList="getList"
  ></PasswordChangeModal>
</template>

<script setup>
// #region import
import { ref, reactive, toRefs, computed, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import {
  API_DisplayAccountList,
  API_AccountStatusChange,
} from "@/api/Modules/DC05/STDSDC05C02";

import moment from "moment";
import Common from "@/util/common.js";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import PasswordChangeModal from "@/components/STDSDC05C04PasswordChange.vue";
import { API_SetFilter } from "@/api/Modules/CM04/STDSCM04C00.js";
const { commit } = useStore();
const router = useRouter();
const accountDataList = ref([]);
const searchKey = ref("");
const refSearchKey = ref(null);
const pageId = ref("STDSDC05C02");
const currentTatsuzinId = ref("");
const noDataMsg = ref(Common.getMessage("MTCL1118", ["アカウント情報"]));

const sort = reactive({
  key: "", // ソートキー
  isAsc: false, // 昇順ならtrue,降順ならfalse
});

// 表示用データリスト
const displayAccountDataList = computed(() => {
  let filteredList = accountDataList.value.filter(
    (item) =>
      item.tatsuzinId?.includes(searchKey.value) ||
      item.accountStatus?.includes(searchKey.value) ||
      item.lastSigninIpAddress?.includes(searchKey.value) ||
      item.lastSignedinDateTimeFormat?.includes(searchKey.value) ||
      item.userName?.includes(searchKey.value)
  );

  let sortedList = Common.listSort2(sort.key, sort.isAsc, filteredList);

  return sortedList;
});

// 件数
const countStr = computed(() => {
  return searchKey.value
    ? `${displayAccountDataList.value.length.toLocaleString()}/${accountDataList.value.length.toLocaleString()}件`
    : `${accountDataList.value.length.toLocaleString()}件`;
});

// NoData Flag
const noDataFlag = computed(() => {
  return displayAccountDataList.value.length === 0;
});

// フィルター条件保存処理
watch(searchKey, (newVal) => {
  const keyWordFilter = {
    searchKey: newVal,
    pageID: pageId.value,
    sessinID: $cookies.get("SessionID"),
  };

  let params = {
    keyWordFilter: keyWordFilter,
  };

  // フィルター条件保存処理
  API_SetFilter(params);
});

// 一覧データを取得
const getList = () => {
  commit("businessModule/processDialogue", true);
  API_DisplayAccountList()
    .then((response) => {
      if (response.result == "0000") {
        // ログインしているtatsuzinId
        currentTatsuzinId.value = response.tatsuzinId;
        $cookies.set("currentLoginId", response.tatsuzinId, "0");

        accountDataList.value = response.accountDataList;
        accountDataList.value.forEach((accountData) => {
          accountData.lastSignedinDateTimeFormat =
            accountData.lastSignedinDateTime
              ? moment(accountData.lastSignedinDateTime).format(
                  "YYYY/MM/DD HH:mm:ss"
                )
              : "-";
        });
        // 保存されているフィルタ条件の適用
        if (
          response.keywordFilter &&
          response.keywordFilter.result === "0000"
        ) {
          searchKey.value = response.keywordFilter.searchKey;
        }
      } else {
        const topError = [
          Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [])
          ),
        ];
        commit("securityModule/updateErrors", topError);
      }
    })
    .finally(() => {
      commit("businessModule/processDialogue", false);
    });
};

const sortData = (key) => {
  Common.sortData2(sort, key);
};

onMounted(() => {
  refSearchKey.value.focus();
  getList();
});
//#endregion

// #region アカウント状態変更
const isAccountStatusChangeShow = ref(false);
const accountStatusChangeMessage = ref("");
const accountStatusChangeParam = reactive({
  userKeyName: "",
  accountLock: false,
});

const accountStatusChange = (accountData) => {
  accountStatusChangeParam.userKeyName = accountData.userKeyName;
  accountStatusChangeParam.accountLock = !accountData.accountLocked;
  let changeStatus = accountData.accountStatus === "有効" ? "無効" : "有効";
  accountStatusChangeMessage.value = Common.getMessage("MTCL2096", [
    accountData.tatsuzinId,
    changeStatus,
  ]);
  isAccountStatusChangeShow.value = true;
};

const accountStatusChangeConfirm = () => {
  // エラーメッセージを初期化
  commit("securityModule/updateErrors", []);
  API_AccountStatusChange(accountStatusChangeParam)
    .then(async (response) => {
      if (response.result == "0000") {
        await getList();
      } else {
        let topError = [];
        if (response.errorCD === "MTCL1126") {
          topError = [
            Common.createError(
              "MTCL1126",
              Common.getMessage("MTCL1126", ["編集"])
            ),
          ];
        } else {
          topError = [
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            ),
          ];
        }

        commit("securityModule/updateErrors", topError);
      }
    })
    .finally(() => {
      isAccountStatusChangeShow.value = false;
    });
};

const accountStatusChangeCancel = () => {
  isAccountStatusChangeShow.value = false;
};
//#endregion

// #region 編集
// 「編集」ボタン押下処理
const handleEdit = (accountData) => {
  //  相談必要　Lock必要
  $cookies.set("STDSDC05C03UserKeyName", accountData.userKeyName, "0");
  $cookies.set("STDSDC05C03TatsuzinId", accountData.tatsuzinId, "0");
  router.push({ name: "STDSDC05C03" });
};
//#endregion

// #region パスワード変更
const isPasswordChangeShow = ref(false);
const passwordChangeTatsuzinId = ref("");
const passwordChangeUserName = ref("");
const passwordChangeUserAuthorityType = ref(1);
const passwordChangeUserKeyName = ref("");
const passwordChangeRequestFlag = ref(false);

// 「パスワード変更」ボタン押下　初期処理
const passwordChange = (accountData) => {
  passwordChangeTatsuzinId.value = accountData.tatsuzinId;
  passwordChangeUserName.value = accountData.userName;
  passwordChangeUserKeyName.value = accountData.userKeyName;
  passwordChangeUserAuthorityType.value = accountData.userAuthorityType;
  passwordChangeRequestFlag.value = accountData.passwordChangeRequest;
  isPasswordChangeShow.value = true;
};

//#endregion
</script>
